export const FileSize = {
  '1MB': 1_048_576,
  '10MB': 10_485_760,
};
